import { Employer } from '@pflegia/data-access';
import { getPublicImageUrl } from '@pflegia/util/functions/s3/get-public-image-url';

export const getEmployerGalleryMainImage = (employer?: Pick<Employer, 'gallery'> | null) => getPublicImageUrl(employer?.gallery?.[0]) ?? '';
